/**
 * useLeadStatusTransition
 * Hook para validar transições de estágio de leads e regras de drag & drop
 */

import { Lead, LeadStage } from '../types/leads';

interface TransitionValidation {
  allowed: boolean;
  reason?: string;
}

export function useLeadStatusTransition() {
  /**
   * Verificar se um lead pode ser arrastado
   */
  const canDragLead = (lead: Lead): boolean => {
    // Leads convertidos e perdidos não podem ser movidos
    if (lead.stage === LeadStage.CONVERTIDO || lead.stage === LeadStage.PERDIDO) {
      return false;
    }
    return true;
  };

  /**
   * Validar transição de estágio
   */
  const validateTransition = (
    lead: Lead,
    targetStage: LeadStage
  ): TransitionValidation => {
    // Não pode mover leads convertidos ou perdidos
    if (lead.stage === LeadStage.CONVERTIDO || lead.stage === LeadStage.PERDIDO) {
      return {
        allowed: false,
        reason: 'Leads convertidos ou perdidos não podem ser movidos'
      };
    }

    // Não pode ir direto para CONVERTIDO (deve usar botão de conversão)
    if (targetStage === LeadStage.CONVERTIDO) {
      return {
        allowed: false,
        reason: 'Use o botão "Converter em Cliente" para converter leads'
      };
    }

    // Não pode ir direto para PERDIDO (deve usar botão específico)
    if (targetStage === LeadStage.PERDIDO) {
      return {
        allowed: false,
        reason: 'Use o botão "Marcar como Perdido" para marcar leads como perdidos'
      };
    }

    // Validações de fluxo lógico (opcional - pode ser mais flexível)
    // Por enquanto permitimos qualquer transição entre os estágios ativos

    return { allowed: true };
  };

  return {
    canDragLead,
    validateTransition
  };
}
